import { useQueryClient as d, useMutation as S, useQuery as q } from "@tanstack/react-query";
import y from "./schedule.api.js";
import { teachurKeys as i } from "../../constants/teachurKeys.js";
const w = (e) => q({
  queryKey: i.availabilitySlots.list(e),
  queryFn: async () => (await y.getAvailabilitySlots(e)).data,
  staleTime: 300 * 1e3,
  keepPreviousData: !0
}), Q = (e) => q({
  queryKey: i.availabilitySlots.day(e),
  queryFn: async () => (await y.getAvailabilitySlots(e)).data,
  staleTime: 300 * 1e3,
  keepPreviousData: !0
}), K = (e) => {
  const r = d();
  return S({
    mutationFn: async (a) => (await y.createAvailabilitySlot(a)).data,
    onSuccess: (a, l, n) => {
      var t;
      r.invalidateQueries({ queryKey: i.availabilitySlots.all }), (t = e == null ? void 0 : e.onSuccess) == null || t.call(e, a, l, n);
    },
    onError: e == null ? void 0 : e.onError,
    ...e
  });
}, b = (e) => {
  const r = d();
  return S({
    mutationFn: async (a) => (await y.createBulkSlots(a)).data,
    onSuccess: (a, l, n) => {
      var t;
      r.invalidateQueries({ queryKey: i.availabilitySlots.all }), (t = e == null ? void 0 : e.onSuccess) == null || t.call(e, a, l, n);
    },
    onError: e == null ? void 0 : e.onError,
    ...e
  });
}, F = (e) => {
  const r = d();
  return S({
    mutationFn: async (a) => (await y.deleteAvailabilitySlot(a)).data,
    onSuccess: (a, l, n) => {
      var t;
      r.invalidateQueries({ queryKey: i.availabilitySlots.all }), (t = e == null ? void 0 : e.onSuccess) == null || t.call(e, a, l, n);
    },
    onError: e == null ? void 0 : e.onError,
    ...e
  });
}, A = (e, r) => {
  const a = d();
  return S({
    mutationFn: async (l) => (await y.bookSlot(l, e)).data,
    onSuccess: (l, n, t) => {
      var u;
      a.invalidateQueries({ queryKey: i.availabilitySlots.all }), a.invalidateQueries({ queryKey: i.scheduledCalls.list(e) }), a.invalidateQueries({ queryKey: i.courses.completion(e) }), (u = r == null ? void 0 : r.onSuccess) == null || u.call(r, l, n, t);
    },
    onError: r == null ? void 0 : r.onError,
    ...r
  });
}, M = (e, r) => q({
  queryKey: i.scheduledCalls.list(e),
  queryFn: async () => (await y.getScheduledCalls(e)).data,
  ...r
}), E = (e) => {
  const r = Intl.DateTimeFormat().resolvedOptions().timeZone;
  return q({
    queryKey: i.scheduledCalls.today(),
    queryFn: async () => (await y.getTodayScheduledCalls(r)).data,
    ...e
  });
}, f = (e) => {
  const r = d(), { onSuccess: a, onError: l, ...n } = e;
  return S({
    mutationFn: async (t) => (await y.acceptScheduledCall(t)).data,
    onSuccess: (t, u, c) => {
      r.setQueriesData(
        { predicate: (s) => s.queryKey[0] === i.scheduledCalls.all[0] },
        (s) => {
          var o;
          return s && {
            ...s,
            data: (o = s.data) == null ? void 0 : o.map(
              (C) => C.id === t.id ? { ...C, ...t } : C
            )
          };
        }
      ), a == null || a(t, u, c);
    },
    onError: (t, u, c) => {
      l == null || l(t, u, c);
    },
    ...n
  });
}, D = (e) => {
  const r = d(), { onSuccess: a, onError: l, ...n } = e;
  return S({
    mutationFn: async ({ callId: t, reason: u }) => (await y.rejectScheduledCall(t, u)).data,
    onSuccess: (t, u, c) => {
      r.setQueriesData(
        { predicate: (s) => s.queryKey[0] === i.scheduledCalls.all[0] },
        (s) => {
          var o;
          return s && {
            ...s,
            data: (o = s.data) == null ? void 0 : o.map(
              (C) => C.id === t.id ? { ...C, ...t } : C
            )
          };
        }
      ), a == null || a(t, u, c);
    },
    onError: (t, u, c) => {
      l == null || l(t, u, c);
    },
    ...n
  });
}, k = (e, r) => {
  const a = d(), { onSuccess: l, onError: n, ...t } = r ?? {};
  return S({
    mutationFn: async ({ callId: u, reason: c }) => (await y.cancelScheduledCall(u, c)).data,
    onSuccess: async (u, c, s) => {
      await a.invalidateQueries({
        queryKey: i.scheduledCalls.all
      }), await a.invalidateQueries({
        queryKey: i.scheduledCalls.today()
      }), e && await a.invalidateQueries({
        queryKey: i.courses.completion(e)
      }), await (l == null ? void 0 : l(u, c, s));
    },
    onError: (u, c, s) => {
      n == null || n(u, c, s);
    },
    ...t
  });
}, T = (e, r) => {
  const a = d(), { onSuccess: l, onError: n, ...t } = r ?? {};
  return S({
    mutationFn: async ({ callId: u, reason: c }) => (await y.studentCancelScheduledCall(u, c)).data,
    onSuccess: async (u, c, s) => {
      await a.invalidateQueries({
        queryKey: i.scheduledCalls.all
      }), await a.invalidateQueries({
        queryKey: i.scheduledCalls.today()
      }), e && await a.invalidateQueries({
        queryKey: i.courses.completion(e)
      }), await (l == null ? void 0 : l(u, c, s));
    },
    onError: (u, c, s) => {
      n == null || n(u, c, s);
    },
    ...t
  });
};
export {
  f as useAcceptScheduledCallMutation,
  A as useBookSlotMutation,
  k as useCancelScheduledCallMutation,
  K as useCreateAvailabilitySlotMutation,
  b as useCreateBulkSlotsMutation,
  F as useDeleteAvailabilitySlotMutation,
  w as useGetAvailabilitySlotsQuery,
  Q as useGetDayAvailabilitySlotsQuery,
  M as useGetScheduledCallsQuery,
  E as useGetTodayScheduledCallsQuery,
  D as useRejectScheduledCallMutation,
  T as useStudentCancelScheduledCallMutation
};
